const DashboardKeys = {
  EHBL_MANIFEST_TITLE: "ehblManifestTitle",
  EHBL_MANIFEST_BY_SUBMITTED_DATE_TITLE: "ehblManifestBySubmittedDateTitle",
  PRIMARY_CCN: "primaryCCN",
  STATUS: "status",
  PORT_OF_DISCHARGE: "portOfDischarge",
  PORT_OF_DESTINATION_EXIT: "portOfDestinationExit",
  HBL_STATUS_RELEASED: "hblStatusReleased",
  MASTER_REFERENCE_NUMBER: "masterReferenceNumber",
  DRAFT: "draft",
  ACCEPTED: "accepted",
  SENT: "sent",
  REJECTED: "rejected",
  STATUS_NOTIFICATION: "statusNotification",
  CANCELLATION_ACCEPTED: "cancellationAccepted",
  CANCELLATION_REJECTED: "cancellationRejected",
  MODIFICATION_REJECTED: "modificationRejected",
  ISF10_TITLE: "isf10Title",
  ISF10_BY_SUBMITTED_DATE_TITLE: "isf10BySubmittedDateTitle",
  TRANSACTION_ID: "transactionId",
  IMPORTER_DOCUMENT_NUMBER: "importerDocumentNumber",
  SHIPMENT_REFERENCE_NUMBER: "shipmentReferenceNumber",
  REFERENCE_BOOKING_NUMBER: "referenceBookingNumber",
  SEE_ALL_RECORDS: "seeAllRecords"
}

export default DashboardKeys